/* eslint-disable jsx-a11y/alt-text */
import React from "react";

import { useGetHomeSvgData } from "../../hooks";
import { TITLE } from "../../helpers/seo";
import { Helmet } from "react-helmet";

const FoodBeveragePage = () => {
  let fileNames = ["food1", "foodbeverages"];
  let data = "";
  /**
   * !This API will call when page set. When response come we are Home Page Data Set
   */
  const { isLoading, data: general_data } = useGetHomeSvgData(fileNames);
  if (!isLoading) {
    data = general_data.data;
  }
  return (
    <>
      <Helmet>
        <title>Food and Beverages | {TITLE}</title>
        <meta
          name="description"
          content="Discover GUIview's solutions for the food and beverage industry, including advanced monitoring and control systems to enhance operational efficiency and quality control."
        />
        <meta
          name="keywords"
          content="Food and Beverages, GUIview, Food Industry Solutions, Production Monitoring, Quality Control, GUI Builder, Cloud View"
        />
      </Helmet>
      <div className="fancy-hero-three">
        <div className="">
          <div className="container">
            <div className="row">
              {/* <div className="col-xl-9 col-lg-10 m-auto">
                <h1 className="heading">Food Beverage</h1>
              </div> */}
              {data &&
                data.svgDataArray.map((val, index) => {
                  if (val.fileName === "food1") {
                    return <object key={index} data={val.svgDataURL}></object>;
                  } else {
                    return null; // Or you can choose to return some other element if the condition is not met
                  }
                })}
            </div>
          </div>
        </div>
        {/* /.bg-wrapper  */}
      </div>

      <div className="fancy-text-block-thirteen pt-40 md-pt-0">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-lg-6 order-lg-last"
              data-aos="fade-left"
              data-aos-duration="1200"
            >
              <div className="">
                <div className="title-style-two">
                  <h2>Food And Beverages</h2>
                  <br />
                </div>
                {/* /.title-style-two */}
                <p>
                  The food and beverage industry can significantly enhance
                  operational efficiency and quality control with GUIview’s
                  advanced solutions, powered by GUI Builder and Cloud View.{" "}
                  <b>GUI Builder</b> provides robust monitoring and control
                  capabilities for production lines, packaging systems, and
                  quality assurance processes. Its intuitive interface ensures
                  seamless integration and real-time visualization of critical
                  parameters, reducing downtime and ensuring product
                  consistency.
                </p>
                <br />
                <p>
                  <b>Cloud View</b> enhances these capabilities by offering
                  remote access to production data and control functions.
                  Managers can monitor operations, receive alerts, and make
                  data-driven decisions from anywhere, ensuring compliance with
                  safety standards and optimizing production efficiency.
                </p>
                <br />
                <p>
                  Together, GUI Builder and Cloud View deliver a comprehensive
                  platform for the food and beverage industry, offering
                  real-time data access, remote monitoring, and enhanced
                  operational control. Trust GUIview to improve efficiency,
                  quality, and compliance in your food and beverage operations
                  with state-of-the-art technology.
                </p>
              </div>
            </div>
            {/* End .col */}
            <div
              className="col-lg-6 col-md-8 m-auto order-lg-first"
              data-aos="fade-right"
              data-aos-duration="1200"
            >
              {data &&
                data.svgDataArray.map((val, index) => {
                  if (val.fileName === "foodbeverages") {
                    return <img key={index} src={val.svgDataURL}></img>;
                  } else {
                    return null; // Or you can choose to return some other element if the condition is not met
                  }
                })}
            </div>
            {/* End .col */}
          </div>
        </div>
      </div>
    </>
  );
};

export default FoodBeveragePage;
